export const body = {
    border: "1px solid black",
    padding: "10px"
};

export const image = {
    height: "150px",
    width: "150px",
    border: "1px solid black"
};

export const columnRight = {
    textAlign: "right"
};

export const customTitle = {
    textDecoration: "underline"
};

export const progressArea = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
};

export const progressBarBack = {
    backgroundColor: "white",
    width: "90%",
    height: "25px"
};

export const progressBarFront = {
    height: "100%",
    backgroundColor: "green"
};

export const printedControls = {
    display: "flex",
    alignItems: "center"
};

export const modelAmounts = {
    paddingTop: "10px",
    paddingBottom: "10px"
};

export const redText = {
    color: "red"
};

//MOBILE
export const mobile_body = {
    border: "1px solid black",
    width: "96%",
    margin: "2%"
};

export const mobile_itemBody = {
    padding: "5px"
};

export const flexRow = {
    display: "flex",
    flexDirection: "row"
};

export const mobile_imageContainer = {
    width: "150px"
};

export const mobile_infoContainer = {
    flex: "1",
    paddingLeft: "5px"
};

export const mobile_totalModels = {
    // border: "1px solid black",
    width: "50%"
};

export const mobile_totalBuilt = {
    // border: "1px solid black",
    width: "50%"
};
